import Fields from '../../fields';
import { Field } from '../../types';

const validateField = <TValue extends any = any>(
  field: Field<TValue>,
  value: TValue,
  values: any,
) => {
  /* Validation based on Field validation property */
  if (field.validation && field.validation.length) {
    const formField = Fields[field.type];
    if (formField && formField.validate) {
      // @ts-expect-error @aryan02420 ts infers field param as never
      return formField.validate(field, value, values);
    }
    return undefined;
  }

  return undefined;
};
export default validateField;
